import React from 'react'

function SystemIcon() {
    return (
      <div data-testid="systemIcon" className="systemIcon">
        <div className="icon" />
      </div>
    )
}

export default SystemIcon
